import { Component, Injector, OnInit, ViewChild } from "@angular/core";
import { EntityChangeDetailModalComponent } from "./entity-change-detail-modal.component";
import { AppComponentBase } from "@shared/app-component-base";
import {
  AuditLogListDto,
  AuditLogServiceProxy,
  EntityChangeListDto,
} from "@shared/service-proxies/service-proxies";
import { ModalDirective } from "ngx-bootstrap/modal";
import { LazyLoadEvent } from "primeng/api";
import { Paginator } from "primeng/paginator";
import { Table } from "primeng/table";
import { finalize } from "rxjs/operators";
import { BsModalRef, BsModalService } from "@node_modules/ngx-bootstrap/modal";
import {
  PagedListingComponentBase,
  PagedRequestDto,
} from "@shared/paged-listing-component-base";
import * as moment from "moment";

export interface IEntityTypeHistoryModalOptions {
  entityTypeFullName: string;
  entityTypeDescription: string;
  entityId: string;
}

@Component({
  templateUrl: "./entity-type-history-modal.component.html",
})
export class EntityTypeHistoryModalComponent
  extends PagedListingComponentBase<EntityChangeListDto>
  implements OnInit
{
  @ViewChild("modal", { static: true }) modal: ModalDirective;
  @ViewChild("dataTable", { static: true }) dataTable: Table;
  @ViewChild("paginator", { static: true }) paginator: Paginator;

  options: IEntityTypeHistoryModalOptions;
  isShown = false;
  isInitialized = false;
  filterText = "";
  tenantId?: number;
  entityHistoryEnabled: false;
  entities: EntityChangeListDto[];

  constructor(
    injector: Injector,
    private _auditLogService: AuditLogServiceProxy,
    public bsModalRef: BsModalRef,
    private _modalService: BsModalService
  ) {
    super(injector);
  }

  protected list(
    request: PagedRequestDto,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this._auditLogService
      .getEntityTypeChanges(
        this.options.entityTypeFullName,
        this.options.entityId,
        "",
        undefined,
        request.skipCount ?? 0,
        request.maxResultCount ?? 10
      )
      .pipe(
        finalize(() => {
          finishedCallback();
        })
      )
      .subscribe((res) => {
        this.entities = res.items;
        this.showPaging(res, pageNumber);
      });
  }

  protected delete(entity: EntityChangeListDto): void {}

  close(): void {
    this.bsModalRef.hide();
  }

  showEntityChangeDetails(record: EntityChangeListDto): void {
    this._modalService.show(EntityChangeDetailModalComponent, {
      class: "modal-lg",
      initialState: {
        entityChange: record,
      },
    });
  }

  ngOnInit(): void {
    this.isShown = true;
    this.getDataPage(1);
  }
}
